import { AxiosResponse } from 'axios'
import { infiniteQueryOptions, queryOptions } from '@tanstack/react-query'
import { createUrl } from './helpers'
import axiosAuth from './config'
import { NTicket } from '../interfaces/services/ticket.interfaces'
import { TicketStatus } from '../interfaces/models/ticket.interfaces'

export const createTicket = async (
  params: NTicket.NCreateTicket.IRequestParams,
  body: NTicket.NCreateTicket.IRequestBody
): Promise<AxiosResponse<NTicket.NCreateTicket.IResponse>> => {
  return axiosAuth.post<NTicket.NCreateTicket.IResponse>(
    createUrl(`/${params.societyId}/ticket`),
    body
  )
}

export const ticketSetChatRead = async (
  params: NTicket.NSetChatRead.IRequestParams
): Promise<AxiosResponse<NTicket.NSetChatRead.IResponse>> => {
  return axiosAuth.post<NTicket.NSetChatRead.IResponse>(
    createUrl(`/${params.societyId}/ticket/${params.ticketId}/set-chat-read`)
  )
}

export const createTicketBoard = async (
  params: NTicket.NCreateTicketBoard.IRequestParams,
  body: NTicket.NCreateTicketBoard.IRequestBody
): Promise<AxiosResponse<NTicket.NCreateTicketBoard.IResponse>> => {
  return axiosAuth.post<NTicket.NCreateTicketBoard.IResponse>(
    createUrl(`/${params.societyId}/ticket/board`),
    body
  )
}

const getTicket = async (
  params: NTicket.NGetTicketInSociety.IRequestParams
): Promise<AxiosResponse<NTicket.NGetTicketInSociety.IResponse>> => {
  return axiosAuth.get<NTicket.NGetTicketInSociety.IResponse>(
    createUrl(`/${params.societyId}/ticket/${params.ticketId}`)
  )
}

const getUnreadTicketsCount = async (
  params: NTicket.NGetUsersUnreadTicketChatCount.IRequestParams,
  query?: NTicket.NGetUsersUnreadTicketChatCount.IRequestQuery
): Promise<AxiosResponse<NTicket.NGetUsersUnreadTicketChatCount.IResponse>> => {
  return axiosAuth.get<NTicket.NGetUsersUnreadTicketChatCount.IResponse>(
    createUrl(`/${params.societyId}/ticket/unread`, query)
  )
}

const getTickets = async (
  params: NTicket.NGetMyTicketsInSociety.IRequestParams,
  query: NTicket.NGetMyTicketsInSociety.IRequestQuery
): Promise<AxiosResponse<NTicket.NGetMyTicketsInSociety.IResponse>> => {
  return axiosAuth.get<NTicket.NGetMyTicketsInSociety.IResponse>(
    createUrl(`/${params.societyId}/ticket`, query)
  )
}
const getTicketMessages = async (
  params: NTicket.NGetTicketMessages.IRequestParams,
  query: NTicket.NGetTicketMessages.IRequestQuery
): Promise<AxiosResponse<NTicket.NGetTicketMessages.IResponse>> => {
  return axiosAuth.get<NTicket.NGetTicketMessages.IResponse>(
    createUrl(`/${params.societyId}/ticket/${params.ticketId}/messages`, query)
  )
}
export const sendTicketMessage = async (
  params: NTicket.NCreateTicketMessage.IRequestParams,
  body: NTicket.NCreateTicketMessage.IRequestBody
): Promise<AxiosResponse<NTicket.NCreateTicketMessage.IResponse>> => {
  return axiosAuth.post<NTicket.NCreateTicketMessage.IResponse>(
    createUrl(`/${params.societyId}/ticket/${params.ticketId}/messages`),
    body
  )
}

const getTicketMedia = async (
  params: NTicket.NGetTicketMedia.IRequestParams,
  query: NTicket.NGetTicketMedia.IRequestQuery
): Promise<AxiosResponse<NTicket.NGetTicketMedia.IResponse>> => {
  return axiosAuth.get<NTicket.NGetTicketMedia.IResponse>(
    createUrl(`/${params.societyId}/ticket/${params.ticketId}/media`, query)
  )
}

const getTicketDocuments = async (
  params: NTicket.NGetTicketDocument.IRequestParams,
  query: NTicket.NGetTicketDocument.IRequestQuery
): Promise<AxiosResponse<NTicket.NGetTicketDocument.IResponse>> => {
  return axiosAuth.get<NTicket.NGetTicketDocument.IResponse>(
    createUrl(`/${params.societyId}/ticket/${params.ticketId}/documents`, query)
  )
}
// Board api

const getTicketAsBoard = async (
  params: NTicket.NGetBoardTicketInSociety.IRequestParams
): Promise<AxiosResponse<NTicket.NGetBoardTicketInSociety.IResponse>> => {
  return axiosAuth.get<NTicket.NGetBoardTicketInSociety.IResponse>(
    createUrl(`/${params.societyId}/ticket/board/${params.ticketId}`)
  )
}
const getBoardTickets = async (
  params: NTicket.NGetBoardTicketsInSociety.IRequestParams,
  query: NTicket.NGetBoardTicketsInSociety.IRequestQuery
): Promise<AxiosResponse<NTicket.NGetBoardTicketsInSociety.IResponse>> => {
  return axiosAuth.get<NTicket.NGetBoardTicketsInSociety.IResponse>(
    createUrl(`/${params.societyId}/ticket/board`, query)
  )
}
const getTicketMessagesAsBoard = async (
  params: NTicket.NGetTicketMessagesAsBoard.IRequestParams,
  query: NTicket.NGetTicketMessagesAsBoard.IRequestQuery
): Promise<AxiosResponse<NTicket.NGetTicketMessagesAsBoard.IResponse>> => {
  return axiosAuth.get<NTicket.NGetTicketMessagesAsBoard.IResponse>(
    createUrl(
      `/${params.societyId}/ticket/board/${params.ticketId}/messages`,
      query
    )
  )
}
export const sendTicketMessageAsBoard = async (
  params: NTicket.NCreateTicketMessage.IRequestParams,
  body: NTicket.NCreateTicketMessage.IRequestBody
): Promise<AxiosResponse<NTicket.NCreateTicketMessage.IResponse>> => {
  return axiosAuth.post<NTicket.NCreateTicketMessage.IResponse>(
    createUrl(`/${params.societyId}/ticket/board/${params.ticketId}/messages`),
    body
  )
}

export const updateTicketStatus = async (
  params: NTicket.NUpdateTicketStatus.IRequestParams,
  body: NTicket.NUpdateTicketStatus.IRequestBody
): Promise<AxiosResponse<NTicket.NUpdateTicketStatus.IResponse>> => {
  return axiosAuth.post<NTicket.NUpdateTicketStatus.IResponse>(
    createUrl(`/${params.societyId}/ticket/board/${params.ticketId}/status`),
    body
  )
}

export const updateTicketVariant = async (
  params: NTicket.NUpdateTicketVariant.IRequestParams,
  body: NTicket.NUpdateTicketVariant.IRequestBody
): Promise<AxiosResponse<NTicket.NUpdateTicketVariant.IResponse>> => {
  return axiosAuth.post<NTicket.NUpdateTicketVariant.IResponse>(
    createUrl(`/${params.societyId}/ticket/board/${params.ticketId}/variant`),
    body
  )
}

export const setAssignedUser = async (
  params: NTicket.NSetUserAsAssigned.IRequestParams,
  body: NTicket.NSetUserAsAssigned.IRequestBody
): Promise<AxiosResponse<NTicket.NSetUserAsAssigned.IResponse>> => {
  return axiosAuth.post<NTicket.NSetUserAsAssigned.IResponse>(
    createUrl(`/${params.societyId}/ticket/board/${params.ticketId}/assign`),
    body
  )
}

const getTicketMediaBoard = async (
  params: NTicket.NGetTicketMediaBoard.IRequestParams,
  query: NTicket.NGetTicketMediaBoard.IRequestQuery
): Promise<AxiosResponse<NTicket.NGetTicketMediaBoard.IResponse>> => {
  return axiosAuth.get<NTicket.NGetTicketMediaBoard.IResponse>(
    createUrl(
      `/${params.societyId}/ticket/board/${params.ticketId}/media`,
      query
    )
  )
}

const getTicketDocumentsBoard = async (
  params: NTicket.NGetTicketDocumentBoard.IRequestParams,
  query: NTicket.NGetTicketDocumentBoard.IRequestQuery
): Promise<AxiosResponse<NTicket.NGetTicketDocumentBoard.IResponse>> => {
  return axiosAuth.get<NTicket.NGetTicketDocumentBoard.IResponse>(
    createUrl(
      `/${params.societyId}/ticket/board/${params.ticketId}/documents`,
      query
    )
  )
}

export const ticketQueries = {
  getTicket: (ticketId?: string, societyId?: string) =>
    queryOptions({
      queryKey: [{ scope: 'ticket', entity: 'getTicket', societyId, ticketId }],
      enabled: !!ticketId && !!societyId,
      queryFn: async ({ queryKey }) => {
        return (
          await getTicket({
            societyId: queryKey[0].societyId!,
            ticketId: queryKey[0].ticketId!,
          })
        ).data.data
      },
    }),
  getTicketAsBoard: (ticketId?: string, societyId?: string) =>
    queryOptions({
      queryKey: [
        { scope: 'ticket', entity: 'getTicketAsBoard', societyId, ticketId },
      ],
      enabled: !!ticketId && !!societyId,
      queryFn: async ({ queryKey }) => {
        return (
          await getTicketAsBoard({
            societyId: queryKey[0].societyId!,
            ticketId: queryKey[0].ticketId!,
          })
        ).data.data
      },
    }),
  getUnreadTicketsCount: (filter: TicketFilterBoard, societyId?: string) =>
    queryOptions({
      queryKey: [
        { scope: 'ticket', entity: 'getUnreadTicketsCount', societyId, filter },
      ],
      enabled: !!societyId,
      queryFn: async ({ queryKey }) => {
        return (
          await getUnreadTicketsCount(
            {
              societyId: queryKey[0].societyId!,
            },
            queryKey[0].filter
          )
        ).data.data
      },
    }),
}

export type TicketFilterResident = {
  status?: TicketStatus[] | TicketStatus
}

export type TicketFilterBoard = {
  status?: TicketStatus[] | TicketStatus
  assignedIds?: string[] | string
  customerIds?: string[] | string
  fromDate?: string
  toDate?: string
}
export const infiniteTicketQueries = {
  tickets: ({
    societyId,
    filter,
  }: {
    societyId?: string
    filter?: TicketFilterResident
  }) =>
    infiniteQueryOptions({
      queryKey: [
        {
          scope: 'ticket',
          entity: 'getTickets',
          societyId,
          ...(filter !== undefined && { filter }),
        },
      ],
      queryFn: async ({ pageParam, queryKey }) => {
        const queryFilter = queryKey[0].filter
        const axiosResp = await getTickets(
          {
            societyId: queryKey[0].societyId!,
          },
          { page: pageParam, ...queryFilter }
        )
        return axiosResp.data.data
      },
      enabled: !!societyId,
      initialPageParam: 0,
      getNextPageParam: (lastPage) => {
        const { currentPage, pages } = lastPage
        const nextPage = currentPage + 1

        if (nextPage > pages) {
          return undefined
        }

        return nextPage
      },
    }),
  ticketsBoard: ({
    societyId,
    filter,
  }: {
    societyId?: string
    filter?: TicketFilterBoard
  }) =>
    infiniteQueryOptions({
      queryKey: [
        {
          scope: 'ticket',
          entity: 'getBoardTickets',
          societyId,
          ...(filter !== undefined && { filter }),
        },
      ],
      queryFn: async ({ pageParam, queryKey }) => {
        const queryFilter = queryKey[0].filter
        const axiosResp = await getBoardTickets(
          {
            societyId: queryKey[0].societyId!,
          },
          { page: pageParam, ...queryFilter }
        )
        return axiosResp.data.data
      },
      enabled: !!societyId,
      initialPageParam: 0,
      getNextPageParam: (lastPage) => {
        const { currentPage, pages } = lastPage
        const nextPage = currentPage + 1

        if (nextPage > pages) {
          return undefined
        }

        return nextPage
      },
    }),
  getTicketMessages: ({
    societyId,
    ticketId,
  }: {
    societyId?: string
    ticketId?: string
  }) =>
    infiniteQueryOptions({
      queryKey: [
        {
          scope: 'ticket',
          entity: 'getTicketMessages',
          societyId,
          ticketId,
        },
      ],
      queryFn: async ({ pageParam, queryKey }) => {
        const axiosResp = await getTicketMessages(
          {
            societyId: queryKey[0].societyId!,
            ticketId: queryKey[0].ticketId!,
          },
          { page: pageParam }
        )
        return axiosResp.data.data
      },
      enabled: !!societyId && !!ticketId,
      initialPageParam: 0,
      getNextPageParam: (lastPage) => {
        const { currentPage, pages } = lastPage
        const nextPage = currentPage + 1

        if (nextPage > pages) {
          return undefined
        }

        return nextPage
      },
    }),
  getTicketMessagesAsBoard: ({
    societyId,
    ticketId,
  }: {
    societyId?: string
    ticketId?: string
  }) =>
    infiniteQueryOptions({
      queryKey: [
        {
          scope: 'ticket',
          entity: 'getTicketMessagesAsBoard',
          societyId,
          ticketId,
        },
      ],
      queryFn: async ({ pageParam, queryKey }) => {
        const axiosResp = await getTicketMessagesAsBoard(
          {
            societyId: queryKey[0].societyId!,
            ticketId: queryKey[0].ticketId!,
          },
          { page: pageParam }
        )
        return axiosResp.data.data
      },
      enabled: !!societyId && !!ticketId,
      initialPageParam: 0,
      getNextPageParam: (lastPage) => {
        const { currentPage, pages } = lastPage
        const nextPage = currentPage + 1

        if (nextPage > pages) {
          return undefined
        }

        return nextPage
      },
    }),

  getTicketMedia: ({
    ticketId,
    societyId,
  }: {
    ticketId?: string
    societyId?: string
  }) =>
    infiniteQueryOptions({
      queryKey: [
        {
          scope: 'ticket',
          entity: 'getTicketMedia',
          societyId,
          ticketId,
        },
      ],
      queryFn: async ({ pageParam, queryKey }) => {
        const axiosResp = await getTicketMedia(
          {
            societyId: queryKey[0].societyId!,
            ticketId: queryKey[0].ticketId!,
          },
          { page: pageParam }
        )
        const data = axiosResp.data?.data
        return data
      },
      enabled: !!societyId && !!ticketId,
      initialPageParam: 0,
      getNextPageParam: (lastPage) => {
        const { currentPage, pages } = lastPage
        const nextPage = currentPage + 1

        if (nextPage > pages) {
          return undefined
        }
        if (!nextPage) return undefined

        return nextPage
      },
    }),
  getTicketDocuments: ({
    ticketId,
    societyId,
  }: {
    ticketId?: string
    societyId?: string
  }) =>
    infiniteQueryOptions({
      queryKey: [
        {
          scope: 'ticket',
          entity: 'getTicketDocuments',
          societyId,
          ticketId,
        },
      ],
      queryFn: async ({ pageParam, queryKey }) => {
        const axiosResp = await getTicketDocuments(
          {
            societyId: queryKey[0].societyId!,
            ticketId: queryKey[0].ticketId!,
          },
          { page: pageParam }
        )
        const data = axiosResp.data?.data
        return data
      },
      enabled: !!societyId && !!ticketId,
      initialPageParam: 0,
      getNextPageParam: (lastPage) => {
        const { currentPage, pages } = lastPage
        const nextPage = currentPage + 1

        if (nextPage > pages) {
          return undefined
        }

        return nextPage
      },
    }),
  getTicketMediaBoard: ({
    ticketId,
    societyId,
  }: {
    ticketId?: string
    societyId?: string
  }) =>
    infiniteQueryOptions({
      queryKey: [
        {
          scope: 'ticket',
          entity: 'getTicketMediaBoard',
          societyId,
          ticketId,
        },
      ],
      queryFn: async ({ pageParam, queryKey }) => {
        const axiosResp = await getTicketMediaBoard(
          {
            societyId: queryKey[0].societyId!,
            ticketId: queryKey[0].ticketId!,
          },
          { page: pageParam }
        )
        const data = axiosResp.data?.data
        return data
      },
      enabled: !!societyId && !!ticketId,
      initialPageParam: 0,
      getNextPageParam: (lastPage) => {
        const { currentPage, pages } = lastPage
        const nextPage = currentPage + 1

        if (nextPage > pages) {
          return undefined
        }

        return nextPage
      },
    }),
  getTicketDocumentsBoard: ({
    ticketId,
    societyId,
  }: {
    ticketId?: string
    societyId?: string
  }) =>
    infiniteQueryOptions({
      queryKey: [
        {
          scope: 'ticket',
          entity: 'getTicketDocumentsBoard',
          societyId,
          ticketId,
        },
      ],
      queryFn: async ({ pageParam, queryKey }) => {
        const axiosResp = await getTicketDocumentsBoard(
          {
            societyId: queryKey[0].societyId!,
            ticketId: queryKey[0].ticketId!,
          },
          { page: pageParam }
        )
        const data = axiosResp.data?.data
        return data
      },
      enabled: !!societyId && !!ticketId,
      initialPageParam: 0,
      getNextPageParam: (lastPage) => {
        const { currentPage, pages } = lastPage
        const nextPage = currentPage + 1

        if (nextPage > pages) {
          return undefined
        }

        return nextPage
      },
    }),
}
